import AssetApi from '@/api/asset/AssetApi.js';
import Asset from '@/views/Asset/Asset.vue';

const state = {
    items: [],
    currentPage: 1, 
    rowsPerPage: 10, 
    total: 0,
    loading: false, 
    statusList: [],
    startIndex: 1,
    endIndex: 10,
    // itemsPerPageOptions: [10, 20, 30, 'All'],
    itemsPerPageOptions: [10, 15],
    search: '',
    initTotal: 0,
    groupList: [],
    groupIds: [],
    drawer: false,
    tempList: [],
    isClick: false,
    detailInfo: [],
    switchState: false,
    detailId: sessionStorage.getItem('detailId') || null,
    dataLoad: false,
    allList: [],
    searchFlag: false,
};

const mutations = {
    setItems(state, items) {
        state.items = items;
    },
    setCurrentPage(state, page) {
        state.currentPage = page;
    },
    setTotal(state, total) { 
        state.total = total;
    },
    setEmptyData(state) {
        state.items = [];
    },
    setLoading(state, loading) {
        state.loading = loading;
    },
    setStatus(state, statusList) {
        state.statusList = statusList;
    },
    setStartIndex(state, startIndex) {
        state.startIndex = startIndex;
    },
    setEndIndex(state, endIndex) {
        state.endIndex = endIndex;
        if(state.total != 0 && state.endIndex >= state.total){
            state.endIndex = state.total
        }
    },
    setRowsPerPage(state, rowsPerPage){
        state.rowsPerPage = rowsPerPage;
    },
    setSearch(state, search) {
        state.search = search;
    },
    setInitTotal(state, initTotal) {
        state.initTotal = initTotal;
    },
    setGroupList(state, groupList){
        state.groupList = groupList;
    },
    setGroupIds(state, groupIds){
        state.groupIds = groupIds;
    },
    setEmptyGroupIds(state){
        state.groupIds = [];
    },
    setDrawer(state, drawer){
        state.drawer = drawer;
    },
    setTempList(state, tempList){
        state.tempList = tempList;
    },
    setIsClick(state, isClick){
        state.isClick = isClick;
    },
    setDetailInfo(state, detailInfo){
        state.detailInfo = detailInfo;
    },
    setSwitchState(state, switchState) {
        state.switchState = switchState;
    },
    setDetailId(state, detailId){
        state.detailId = detailId;
    },
    setDataLoad(state, dataLoad){
        state.dataLoad = dataLoad;
    },
    setAllList(state, allList){
        state.allList = allList;
    },
};

const actions = {
    updateCurrentPage({ commit, dispatch, state }, page) {

        // console.log("확인1")

        dispatch('updateDrawer', false);
        commit('setCurrentPage', page);
        commit('setLoading', true); 
        let start = (page - 1) * state.rowsPerPage + 1;
        let end = page * state.rowsPerPage;

        if (state.total != 0 && end >= state.total) {
            end = state.total;
        }

        // console.log("확인 => ", start)
        // console.log("확인 => ", end)

        commit('setStartIndex', start);
        commit('setEndIndex', end);
        // commit('setLoading', false); 
        // await dispatch('fetchAllAsset');
        // await dispatch('loadList');
        // await dispatch('fetchStatus');
    },
    async fetchAllAsset({ commit, state }) {
        try {
            // console.log("[2]");
            const params = {
                page: state.currentPage,
                rowsPerPage: state.rowsPerPage
            };
            commit('setEmptyData');
            commit('setLoading', true);  
            const response = await AssetApi.listApi(params);
            //console.log('response : ', response);

            const temp = response.list.map(e => {
                const key = (e.encodingInfo).map(a => Object.keys(a)[0]);
                const info = (e.encodingInfo).map(a => Object.values(a)[0]);
                // console.log("데이터 추출용 => ", (e.status.map(e => e.status).map(e=>e)))
                const statusDatas = e.status.map(e => e);


                // console.log("데이터 추출용 => ", statusDatas)
                // commit('setStatus', statusDatas);
                const img = info.map(e => e.thumbnail)[0];
                const type = info.map(e => e.type);
                return {
                    ...e,
                    image: img ?? null,
                    statusDatas: statusDatas,
                    encoding_type: type
                };
            });
            //console.log('temp : ', temp);
            const tot = response.total;

            commit('setItems', temp);
            commit('setTotal', tot); 
            commit('setInitTotal', tot);
        } catch (error) {
            console.error("error", error);
            commit('setEmptyData');
        } finally {
            commit('setLoading', false); 
        }
    },
    updateTotal({commit, state}, total){
        commit('setTotal', total); 
    },
    async noEmptyload({ commit, state }) {
        try {
            const params = {
                page: state.currentPage,
                rowsPerPage: state.rowsPerPage
            };
         
            const response = await AssetApi.listApi(params);
            //console.log("여기 실행?noEmptyload", response);
           
        
            const res = response.list.map(e => e);
            //console.log("noEmptyload => ", res);

            const tot = response.total;


            commit('setItems', res);
            commit('setTotal', tot); 
            commit('setInitTotal', tot);
            return res;
        } catch (error) {
            console.error("error", error);
        } finally {
       
        }
    },
    async loadList({ commit, state, dispatch }) {
        try {
            const params = {
                page: state.currentPage,
                rowsPerPage: state.rowsPerPage
            };
            commit('setEmptyData');
            // commit('setLoading', true); 
            const response = await AssetApi.listApi(params);
            //console.log("여기 실행?response", response);
            commit('setLoading', true); 
            // const temp = response.list.map(e => {
            //     // let img = null;
            //     let type = [];
            //     const encodeInfo = e.encodingInfo.map(e => e);
            //     const info = e.statusData.flatMap(e => e);
            //     const statusInfo = Object.values(info[0]).flatMap(e =>e)
            //     // console.log("statusInfo => ", Object.values(statusInfo[0]).flatMap(e =>e.status));
            //     type = e.encoding_type.flatMap(e => e)
            //     const firstVal = type.map(item => item[0]);
            //     const tagData = e.tag.map(e => e.tag_name);

            //     return {
            //         ...e,
            //         statusInfo: statusInfo,
            //         types: firstVal,
            //         tagData: tagData
            //     };  
            // });
            // const res = temp.flatMap(e => e);
            let res;
            if(response.total > 0){
                res = response.list.map(e => e);
                // console.log("res => ", res)
            
                // console.log("loadList res=> ", res.map(e => e.sortOut));
               
    
                const tot = response.total;
                // console.log("loadList tot=> ", tot);
                commit('setItems', res);
                commit('setTotal', tot); 
                // let start = state.currentPage;
                // let end = state.currentPage * state.rowsPerPage;
                // if (end >= state.total) {
                //     end = state.total;
                // }
                
                commit('setStartIndex', state.startIndex);
                commit('setEndIndex', state.endIndex);
                commit('setInitTotal', tot);
            }
            else {
                res = [];
            }

            return res;
          
        } catch (error) {
            console.error("error", error);
            commit('setEmptyData');
        } finally {
            commit('setLoading', false); 
            setTimeout(() => {
                commit('setDataLoad', true);
              }, 2000);
        }
    },
    async fetchStatus({ commit, state }) {
        // try {
        //     // console.log("[3]");
        //     const params = {
        //         page: state.currentPage,
        //         rowsPerPage: state.rowsPerPage
        //     };
        //     const response = await AssetApi.statusApi(params);
        //     console.log('status response : ', response);

        //     const updatedItems = state.items.map(item => {
        //         const val = response.filter(e => e.origin_asset_id === item.assetId);
        //         if (val.length > 0) {
        //             // const datas = val.map(e => e.status);
        //             return { ...item, status: val};
        //         } else {
        //             return item;
        //         }
        //     });
        //     commit('setItems', updatedItems);
        //     // console.log('[3] items : ', state.items);
        //     commit('setStatus', response);
        //     // commit('setTempList', state.items);
        //     // console.log('tempList : ', state.tempList);
        // } catch (error) {
        //     console.error("error : ", error);
        // } 
    },
    async fetchAllList({commit}){

        try {
            const response = await AssetApi.getAllList();
            // console.log("response => ", response)
            commit('setAllList', response.list);
            return response.list;
            // if(response.status === 1){
            //     const res = Object.values(response.list).map(e => e);
            //     // console.log("res => ", res)
            //     commit('setAllList', res);
            // }
        } catch (error) {
           
        }
    },

    updateRowsPerPage({ commit, dispatch, state }, rowsPerPage) {

        if(rowsPerPage === 'All'){
            rowsPerPage = state.total;
        }     
        // console.log("[4] rowsPerPage ", rowsPerPage);
        commit('setRowsPerPage', rowsPerPage);
        // // console.log("update확인 => ",rowsPerPage)
        dispatch('updateCurrentPage', 1);

        // console.log("확인 1 => ", state.rowsPerPage)
        // console.log("확인 2 => ", state.startIndex)
        // console.log("확인 3 => ", state.endIndex)
        // console.log("확인 4 => ", state.currentPage)
    },
    async updateSearch({ commit, dispatch, state }, search) {

        // dispatch('updateRowsPerPage', 'All')
        // const searchList = state.allList;
        // console.log("searchList => ", searchList)
        const initCurrentPage = state.currentPage;

        commit('setSearch', search);
        let filters;
        if (search.trim() === '') {
            filters = state.allList;
        } else {
            const newSearch = search.toLowerCase();
            filters = state.allList.filter(item => {
                const names = item.name.toLowerCase();
                const tags = item.tag.map(e => e.tag_name.toLowerCase());
                return names.includes(search) || tags.some(e => e.includes(newSearch));

            });  
            const valPage = search.trim() === '' ? initCurrentPage : 1;
            const val = search.trim() === '' ? state.initTotal : filters.length;
            commit('setCurrentPage', valPage);
            commit('setTotal', val);
            let start = state.currentPage;
            let end = state.currentPage * state.total;
            if (end >= state.total) {
                end = state.total;
            }
            commit('setStartIndex', start);
            commit('setEndIndex', end);
        }
    },
    // updateTotalPages({ commit }, val) {
    //     // console.log("[6]");
    //     // console.log("val : ", val);
    //     commit('setTotal', val);
    // },
    async refreshList({commit, state, dispatch}){
        // dispatch('updateDrawer', false);
        // await dispatch('fetchAllAsset');
        try {
            dispatch('updateDrawer', false);
            commit('setLoading', true); 
            const res = await dispatch('loadList');
            return res;
            // commit('setLoading', true); 
            // commit('setEmptyData'); 
            // const params = {
            //     page: state.currentPage,
            //     rowsPerPage: state.rowsPerPage
            // };
            // const response = await AssetApi.allListApi(params);
            // console.log('allListApi res : ', response);

            // const temp = response.list.map(e => {
               
            // });

            // commit('setItems', temp);
        } catch (error) {
            console.error("error", error);
            commit('setEmptyData');
        } finally {
            commit('setLoading', false); 
        }
    },
    async grouping({commit}, params){
        const response = await AssetApi.addInGroupApi(params);
        // commit('setEmptyGroupIds');
        return response.status;
    },

    async groupingSingle({commit}, params){
        const response = await AssetApi.addInGroupSingleApi(params);
        // commit('setEmptyGroupIds');
        return response.status;
    },

    async fetchGroupList({commit}){
        const response = await AssetApi.groupApi();

        const list = response.map(item => ({
            id: item.id,
            group_name: item.group_name
          }));
        commit('setGroupList', list); 
    },
    async fetchInGroupInfo({commit}, asset_id){
        const response = await AssetApi.inGroupInfoApi(asset_id);
        const info = response.map(item => item.id);
        commit('setGroupIds', info);
    },
    async updateGroupIds({commit}, data){
        const datas = data.map(e => e.id);
        commit('setGroupIds', datas);
    },
    async delAssetDatas({commit}, params){
        const response = await AssetApi.deleteAllApi(params);
        // console.log("삭제 res => ", response.status);

        return response.status;
    },
    updateDrawer({commit}, value){
        commit('setDrawer', value);
    },
    async fetchGroupListItems({commit, state}, params){
        // commit('setEmptyData');
        // commit('setLoading', true);
        const response = await AssetApi.inGroupApi(params);
        return response;
        // commit('setItems', response);
        // commit('setLoading', false);
    },
    updateClickBtn({commit}, value){
        commit('setIsClick', value);
    },
    sendAssetName({commit}, value){
        commit('setName', value);
    },
    async insertReqEncodeData({commit}, params){
        const response = await AssetApi.reqEncodeApi(params);
        //console.log("insertReqEncodeData res => ", response);

        return response.status;
    },
    async updateDistribution({commit}, params){
        const newState = params['newState'];
        // commit('setSwitchState', newState);
        const response = await AssetApi.distributionApi(params);
        //console.log("[updateDistribution] => ", response.status)
        // if(response.status !== 1){
        //     commit('setSwitchState', !newState);
        // }
        return response.status;
    },
    async fetchDetailInfo({commit, state}){
        const id = state.detailId;
        const response = await AssetApi.assetDetailApi(id);
        if(response.status === 1){
            commit('setDetailInfo', response.list);
        }
    },
    fetchDetailId({commit}, id){
        commit('setDetailId', id);
        sessionStorage.setItem('detailId', id);
    },

    
    async deleteTag({commit}, params){
        const response = await AssetApi.deleteTagApi(params);
        // console.log("delTag res => ", response);

        return response.status;
    },
    async uploadTask({commit}, formData){
        const response = await AssetApi.uploadTnApi(formData);
        return response.status;
        // if(response.status === 1){
        //     dispatch('fetchDetailInfo');
        // }
    },
    async deleteTask({commit, dispatch}, params){
        const response = await AssetApi.deleteTnApi(params);
        // if(response.status === 1){
        //     dispatch('fetchDetailInfo');
        // }
        return response.status;
    },

    async delSingle({commit}, params){
        const response = await AssetApi.delSingleApi(params);
        return response.status;
    },
    async addTag({commit}, params){
        const response = await AssetApi.addTagApi(params);
        return response.status;
    },
    async updateDatas({commit}, params) {
        const response = await AssetApi.updateInfoApi(params);
        return response.status;
    },
    async updateGroup({commit}, params){
        const response = await AssetApi.updateGroupApi(params);
        return response;
    },
    async checkEncoding({commit}, params){
        const response = await AssetApi.reqCheck(params);
        return response;
    }
};

const getters = {
    items: (state) => {
        return state.items.slice(state.startIndex, state.endIndex);
    },
    totalPages: (state) => state.total,
    currentPage: (state) => state.currentPage,
    loading: (state) => state.loading, 
    rowsPerPage: state => state.rowsPerPage,
    itemsPerPageOptions: state => state.itemsPerPageOptions,
    totalLength: state => state.totalLength,
    initTotal: state => state.initTotal,
    statusList: state => state.statusList,
    groupList: state => state.groupList,
    groupIds: state => state.groupIds,
    drawer: state => state.drawer,
    tempList: state => state.tempList,
    isClick: state => state.isClick,
    detailInfo: state => state.detailInfo,
    switchState: state => state.switchState,
    detailId: state => state.detailId,
    dataLoad: state => state.dataLoad,
    allList: state => state.allList,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};